import { LifeBuoy } from "lucide-react";
import { cn } from "@/lib/utils";
import { useSupportSession } from "@/contexts/SupportSessionContext";

/**
 * Permanent badge shown beside the TransportMate logo while a support session
 * is active. Renders nothing for normal users.
 */
export function SupportModeBadge({ className }: { className?: string }) {
  const { session, isReadOnly } = useSupportSession();
  if (!session) return null;

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full bg-orange-500 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-white shadow-sm",
        className
      )}
      title={`${session.companyName} — ${isReadOnly ? "Read only" : "Editing enabled"}`}
    >
      <LifeBuoy className="h-3 w-3" />
      Support Mode
      <span className="hidden sm:inline font-normal normal-case opacity-90">
        · {session.companyName}
      </span>
    </span>
  );
}
